import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useAuth } from "../auth/authHooks";
import RouterNavigation from "./RouterNavigation";
import routes from "./routes";

const BootstrapRoutes = () => {
  const auth = useAuth();

  return (
    <BrowserRouter>
      <Switch>
        {routes.map((routeGroup) => {
          const Layout = routeGroup.layoutComponent;

          return routeGroup.children.map((route) => {
            let children = route.element;
            if ((route.authRequired === true && !auth.user) || (route.authRequired === false && !!auth.user))
              children = (
                <RouterNavigation
                  key={route.id}
                  url={route.authRedirectUrl}
                  withRedirectUrlParam={route.withRedirectUrl}
                />
              );
            return (
              <Route key={route.id} exact={route.exact} path={route.path}>
                <Layout>{children}</Layout>
              </Route>
            );
          });
        })}
      </Switch>
    </BrowserRouter>
  );
};

export default BootstrapRoutes;
